import laVilaCover from '../../../assets/images/la-villa-restaurant.jpg';
import shanghaiCover from '../../../assets/images/shanghai-restaurant.jpg';
import { abstract, lavillaAbout, shanghaiAbout } from './restaurants';
import shanghaiCover1 from '../../../assets/images/food/shanghai/shanghai4.jpeg';

const frontpage = {
  subtitle: 'Mediterranean, Chinese & Sushi Cuisine',
  welcome: {
    title: 'About Hotel',
    subtitle: 'La Villa Boutique Hotel wishes you a warm welcome and a pleasant stay at the hotel premises',
    body:
      'Feel the charm of the Old Town, enjoying the comfortable and modern Mediterranean ambiance with both magnificent marina sea view and Budva city. Sophistic Boutique Hotel ' +
      'emphasizing the privacy secluded in just five fully equipped air-conditioned suites. All suites offer plenty of space, king size bed, comfortable sofa, with a cable TV channels, free Wi-Fi, ' +
      'modern bathroom with luxury bathrobes, big safe box for laptop and personal belongings, parking and many other leisures for a complete enjoyment. The hotel is nestled in the historic ' +
      'building dating back the 17th century, located in a quiet area of Budva Old Town recognized by the UNESCO as the World Heritage site.\n\n' +
      'Beside the idyllic location of La Villa, a short walk from the sandy shoreline of Pizana, and 20km from the nearest airport, it also grants the opportunity to indulge in gastronomic adventures. There is an Asian oriented restaurant on-site, Shanghai restaurant. While seated in a covered patio lit ' +
      'up by the glorious rays of the sun you can treat yourself in a delicious Asian menu as per your choice: Chinese cuisine or Japanese sushi delicacies.\n\n' +
      'La Villa Boutique Hotel offers rich a la carte Montenegrin breakfast included in the room rate. Served at secluded terrace under the shade of vine or indoors at elegant La Villa restaurant, it is a delightful experience for our guests.\n\n' +
      'La Villa tailor made tours and activities will give you a chance to get familiar with natural beauty of Montenegro.\n\n' +
      'Weather you would like to rent a yacht for a whole day trip, panoramic ride via Budva bay with a boat or submarine tour or you need transfer from Tivat, Podgorica or Dubrovnik airport our dedicated team is here to easily organise the best for your enjoyment and convenience. ' +
      'Budva or Boka bay cruising, kayaking, paddle-boarding, wine and Montenegrin cuisine tasting, Skadar lake trip or similar are some of the most popular trips among our guests.',
  },
  restaurants: {
    common: { body: abstract },
    left: {
      title: 'Shanghai',
      linkTo: '/restaurant/shanghai',
      logo: require('../../../assets/images/shanghaiLogo.png'),
      cover: shanghaiCover,
      cover1: shanghaiCover1,
      body: shanghaiAbout,
    },
    right: {
      title: 'LaVilla',
      linkTo: '/restaurant/lavilla',
      logo: require('../../../assets/images/laVillaLogo.png'),
      cover: laVilaCover,
      body: lavillaAbout,
    },
  },
  team: {
    title: 'Why La Villa?',
    about:
      'Because, we are to organize your bespoken summer holiday with elaboration.\nBecause it is going to be the holiday you have been longing for a year. \nBecause, it is hospitality, warmth and gleefulness not being charged for but shared with you for free.',
    members: [
      // require('../../../assets/images/team/team1.jpeg'),
      // require('../../../assets/images/team/team2.jpeg'),
      require('../../../assets/images/team/team3.jpeg'),
      require('../../../assets/images/team/team4.jpeg'),
      // require('../../../assets/images/team/team5.jpeg'),
    ],
  },
};

export default frontpage;